import { StrictMode } from "react";
import { createRoot } from "react-dom/client";
import "./index.css";
import App from "./App";
import ErrorScreen from "./components/ErrorScreen";
import { FactorsProvider } from "./state/FactorsContext";

createRoot(document.getElementById("root")!).render(
  <StrictMode>
    <ErrorScreen>
      <FactorsProvider>
        <App />
      </FactorsProvider>
    </ErrorScreen>
  </StrictMode>,
);
